<template>
  <section class="inner_banner presale_page" id="PreSale">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 presale_desc">
          <span> ETH Fighter will be be launching in Q2 2021 </span>
          <br />
          <span>
            Start your Eth Fighter collection by purchasing an ETH Fighter crate
          </span>
          <br />
          <span>
            Each crate will offer 1 x random ETH fighter character from that
            crate type, with a 0.05 % chance of receiving a character from the
            crate league above.
          </span>
        </div>
      </div>
      <div class="presale_box desktop">
        <article class="row">
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/common.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('common-presale-1')"
                  src="../assets/images/common-box.png"
                  alt=""
                  v-scroll-to="'#btn-common-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/rare.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('rare-presale-1')"
                  src="../assets/images/rare-box.png"
                  alt=""
                  v-scroll-to="'#btn-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/lagendry.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('super-rare-presale-1')"
                  src="../assets/images/legendary-box.png"
                  alt=""
                  v-scroll-to="'#btn-super-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/epic.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('ultra-rare-presale-1')"
                  src="../assets/images/epic-box.png"
                  alt=""
                  v-scroll-to="'#btn-ultra-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
        </article>
      </div>

      <div class="presale_box mobile">
        <article class="row">
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/common.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('common-presale-1')"
                  src="../assets/images/common-box.png"
                  alt=""
                  v-scroll-to="'#btn2-common-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/rare.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('rare-presale-1')"
                  src="../assets/images/rare-box.png"
                  alt=""
                  v-scroll-to="'#btn2-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/lagendry.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('super-rare-presale-1')"
                  src="../assets/images/legendary-box.png"
                  alt=""
                  v-scroll-to="'#btn2-super-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="presale_box_inner">
              <img src="../assets/images/epic.png" alt="" />
              <div class="image_box">
                <img
                  @click.prevent="setAndScroll('ultra-rare-presale-1')"
                  src="../assets/images/epic-box.png"
                  alt=""
                  v-scroll-to="'#btn2-ultra-rare-presale-1'"
                />
              </div>
            </div>
          </aside>
        </article>
      </div>

      <div class="presale_tabs desktop">
        <div class="tab" role="tabpanel">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li v-for="tab in tabs" :key="tab.id">
              <a
                href="#"
                @click.prevent="current = tab.id"
                :class="{ active: current === tab.id }"
              >
                <img src="../assets/images/gift-box.png" alt="" />{{
                  tab.title
                }}</a
              >
            </li>
          </ul>
          <div class="tab-content tabs">
            <div
              role="tabpanel"
              class="tab-pane fade"
              v-for="tab in tabs"
              :key="tab.id"
              :class="{ 'active show': current === tab.id }"
            >
              <article class="row">
                <aside class="col-lg-6 col-md-12">
                  <img :src="tab.thumb" alt="" v-if="!tab.isInProgress" />
                  <span v-if="tab.isInProgress">
                    Once your transaction has confirmed your character will be
                    revealed here
                  </span>
                </aside>
                <aside class="col-lg-6 col-md-12" :id="`btn-${tab.id}`">
                  <div class="presale_tab_detail">
                    <div class="presale_tab_detail_title">
                      <h4>{{ tab.desc }}</h4>
                      <p>You will receive one of these items only</p>
                    </div>
                    <article class="row">
                      <aside
                        v-for="(item, $index) in tab.characters"
                        :key="$index"
                        class="col-md-3 col-sm-6"
                      >
                        <div>
                          <img :src="item.thumb" alt="" />
                        </div>
                        <div class="presale_tab_detail">
                          {{ item.mintLimit - item.mintCount }} /
                          {{ item.mintLimit }} Left
                        </div>
                      </aside>
                    </article>
                    <div class="get_more_carates">
                      <h3>Select Crate Quantity</h3>
                      <div class="get_more_carates_inner">
                        <div class="number">
                          <span class="minus" @click="tab.quantity--">-</span>
                          <input
                            v-model="tab.quantity"
                            type="number"
                            value="1"
                            min="1"
                          />
                          <span class="plus" @click="tab.quantity++">+</span>
                        </div>
                        <div class="eth_number">
                          <span
                            >{{
                              (tab.price * tab.quantity).toFixed(3)
                            }}
                            ETH</span
                          >
                        </div>
                        <div class="buy_button">
                          <a href="#" @click.prevent="buy(tab)"
                            ><img src="../assets/images/buy_now.png" alt=""
                          /></a>
                          <div v-if="currentHash">
                            <a
                              :href="`http://etherscan.io/tx/${currentHash}`"
                              target="_blank"
                            >
                              [View Tx]
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="crate_stock">
                      <p>Crate Stock {{ tab.stock }} / {{ tab.supply }}</p>
                      <p>
                        Crate Price{{ tab.price }}ETH (<strike
                          >{{ tab.normalPrice }} ETH</strike
                        >) {{ tab.discount }}
                        discount
                      </p>
                    </div>
                    <div class="rare_gift">
                      <div class="plus_icon">
                        <img src="../assets/images/plus.png" alt="" />
                      </div>
                      <div class="rare_gift_inner" v-if="tab.bonusCrateName">
                        <p>
                          *0.05% Chance of Receiving a
                          {{ tab.bonusCrateName }} Crate
                        </p>
                        <img :src="tab.thumbNext" alt="" />
                      </div>
                    </div>
                  </div>
                </aside>
              </article>
              <div class="special_notice">
                <h4>The ETH Fighter presale is taking place over 4 stages</h4>
                <h4>Stage 1 - 40 percent discount - Completed</h4>
                <h4>Stage 2 - 30 percent discount - Completed</h4>
                <h4>Stage 3 - 20 percent discount - Live now!</h4>
                <h4>Stage 4 - 10 percent discount</h4>
                <h4>
                  Choice of 4 crate types for sale - Common, Rare, Legendary and
                  Epic Each crate has a different selection of characters, each
                  crate purchased will reveal and issue one random character.
                </h4>
              </div>
              <div class="character_stats">
                <h4>Character Stats</h4>
                <div class="character_stats_head">
                  <article class="row align-items-center">
                    <aside class="col-md-6">
                      <div class="character_stats_head_left">
                        <h5>
                          <img src="../assets/images/gift-box.png" alt="" />{{
                            tab.head
                          }}
                        </h5>
                      </div>
                    </aside>
                    <aside class="col-md-6">
                      <h6>{{ tab.headPrice }}</h6>
                    </aside>
                  </article>
                </div>
                <div class="character_crate_box">
                  <article class="row">
                    <aside
                      class="col-md-3"
                      v-for="part in tab['fullCharacters']"
                      :key="part.id"
                    >
                      <div class="character_crate_box_inner">
                        <img :src="part.thumb" alt="" />
                      </div>
                    </aside>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="presale_tabs mobile">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default" v-for="tab in tabs" :key="tab.id">
            <div class="panel-heading" role="tab">
              <h4 class="panel-title">
                <a
                  role="button"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  @click.prevent="current = tab.id"
                  :href="`#collapse${tab.id}`"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                  class="collapsed"
                >
                  {{ tab.title }}
                </a>
              </h4>
            </div>
            <div
              :id="`#collapse${tab.id}`"
              :class="{
                'panel-collapse collapse show': current === tab.id,
                ' collapse': current != tab.id,
              }"
              role="tabpanel"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div class="panel-body">
                <div class="tab-pane">
                  <article class="row">
                    <aside class="col-lg-6 col-md-12">
                      <img :src="tab.thumb" alt="" />
                    </aside>
                    <aside class="col-lg-6 col-md-12">
                      <div class="presale_tab_detail">
                        <div class="presale_tab_detail_title">
                          <h4>{{ tab.desc }}</h4>
                          <p>You will receive one of these items only</p>
                        </div>
                        <article class="row">
                          <aside
                            v-for="(item, $index) in tab.characters"
                            :key="$index"
                            class="col-md-3 col-sm-6"
                          >
                            <div>
                              <img :src="item.thumb" alt="" />
                            </div>
                            <div class="presale_tab_detail">
                              {{ item.mintLimit - item.mintCount }} /
                              {{ item.mintLimit }} Left
                            </div>
                          </aside>
                        </article>
                        <div class="get_more_carates">
                          <h3>Select Crate Quantity</h3>
                          <div class="get_more_carates_inner">
                            <div class="number">
                              <span class="minus" @click="tab.quantity--"
                                >-</span
                              >
                              <input
                                v-model="tab.quantity"
                                type="number"
                                value="1"
                                min="1"
                              />
                              <span class="plus" @click="tab.quantity++"
                                >+</span
                              >
                            </div>
                            <div class="eth_number">
                              <span
                                >{{
                                  (tab.price * tab.quantity).toFixed(3)
                                }}
                                ETH</span
                              >
                            </div>
                            <div class="buy_button" :id="`btn2-${tab.id}`">
                              <a href="#" @click.prevent="buy(tab)"
                                ><img src="../assets/images/buy_now.png" alt=""
                              /></a>
                              <div v-if="currentHash">
                                <a
                                  :href="`http://etherscan.io/tx/${currentHash}`"
                                  target="_blank"
                                >
                                  [View Tx]
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="crate_stock">
                          <p>Crate Stock {{ tab.stock }} / {{ tab.supply }}</p>
                          <p>
                            Crate Price{{ tab.price }}ETH (<strike
                              >{{ tab.normalPrice }} ETH</strike
                            >) {{ tab.discount }}
                            discount
                          </p>
                        </div>
                        <div class="rare_gift">
                          <div class="plus_icon">
                            <img src="../assets/images/plus.png" alt="" />
                          </div>
                          <div
                            class="rare_gift_inner"
                            v-if="tab.bonusCrateName"
                          >
                            <p>
                              *0.05% Chance of Receiving a
                              {{ tab.bonusCrateName }} Crate
                            </p>
                            <img :src="tab.thumbNext" alt="" />
                          </div>
                        </div>
                      </div>
                    </aside>
                  </article>
                  <div class="special_notice">
                    <h4>
                      The ETH Fighter presale is taking place over 4 stages
                    </h4>
                    <h4>Stage 1 - 40 percent discount - Completed</h4>
                    <h4>Stage 2 - 30 percent discount - Completed</h4>
                    <h4>Stage 3 - 20 percent discount - Live now!</h4>
                    <h4>Stage 4 - 10 percent discount</h4>
                    <h4>
                      Choice of 4 crate types for sale - Common, Rare, Legendary
                      and Epic Each crate has a different selection of
                      characters, each crate purchased will reveal and issue one
                      random character.
                    </h4>
                  </div>
                  <div class="character_stats">
                    <h4>Character Stats</h4>
                    <div class="character_stats_head">
                      <article class="row align-items-center">
                        <aside class="col-md-6">
                          <div class="character_stats_head_left">
                            <h5>
                              <img
                                src="../assets/images/gift-box.png"
                                alt=""
                              />{{ tab.head }}
                            </h5>
                          </div>
                        </aside>
                        <aside class="col-md-6">
                          <h6>{{ tab.headPrice }}</h6>
                        </aside>
                      </article>
                    </div>
                    <div class="character_crate_box">
                      <article class="row">
                        <aside
                          class="col-md-3"
                          v-for="part in tab['fullCharacters']"
                          :key="part.id"
                        >
                          <div class="character_crate_box_inner">
                            <img :src="part.thumb" alt="" />
                          </div>
                        </aside>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { ethers } from "ethers";

export default {
  name: "PreSale",
  data() {
    return {
      currentHash: null,
      current: "common-presale-1",
      crates: {
        "common-presale-1": {
          id: "common-presale-1",
          title: "Common",
          desc: "COMMON LOOT CRATE REWARDS",
          quantity: 1,
          stock: 0,
          supply: 400 * 4,
          price: 0.016,
          normalPrice: 0.02,
          discount: "20%",
          bonusCrateName: "Rare",
          thumb: require("../assets/images/common-box2.png"),
          isInProgress: false,
          thumbNext: require("../assets/images/rare-box2.jpg"),
          characters: [
            {
              id: 20,
              thumb: require("../assets/images/presale-detail1.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 18,
              thumb: require("../assets/images/presale-detail2.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 15,
              thumb: require("../assets/images/presale-detail3.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 14,
              thumb: require("../assets/images/presale-detail4.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
          head: "Common Loot Crate",
          headPrice: "Common Crate - Total 32000",
          fullCharacters: [
            {
              id: 20,
              thumb: require("../assets/images/crate1.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 18,
              thumb: require("../assets/images/crate2.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 15,
              thumb: require("../assets/images/crate3.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 14,
              thumb: require("../assets/images/crate4.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
        },
        "rare-presale-1": {
          id: "rare-presale-1",
          title: "Rare",
          desc: "RARE LOOT CRATE REWARDS",
          quantity: 1,
          stock: 0,
          supply: 200 * 4,
          price: 0.064,
          normalPrice: 0.08,
          discount: "20%",
          bonusCrateName: "Legendary",
          thumb: require("../assets/images/rare-box2.jpg"),
          isInProgress: false,
          thumbNext: require("../assets/images/legendary-box2.png"),
          characters: [
            {
              id: 6,
              thumb: require("../assets/images/presale-detail5.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 8,
              thumb: require("../assets/images/presale-detail6.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 7,
              thumb: require("../assets/images/presale-detail7.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 3,
              thumb: require("../assets/images/presale-detail8.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
          head: "Rare Loot Crate",
          headPrice: "Rare Crate - Total 16000",
          fullCharacters: [
            {
              id: 6,
              thumb: require("../assets/images/crate5.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 8,
              thumb: require("../assets/images/crate6.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 7,
              thumb: require("../assets/images/crate7.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 3,
              thumb: require("../assets/images/crate8.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
        },
        "super-rare-presale-1": {
          id: "super-rare-presale-1",
          title: "Legendary",
          desc: "LEGENDARY LOOT CRATE REWARDS",
          quantity: 1,
          stock: 0,
          supply: 50 * 3,
          price: 0.24,
          normalPrice: 0.3,
          discount: "20%",
          bonusCrateName: "Epic",
          thumb: require("../assets/images/legendary-box2.png"),
          isInProgress: false,
          thumbNext: require("../assets/images/epic-box2.png"),
          characters: [
            {
              id: 10,
              thumb: require("../assets/images/presale-detail9.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 5,
              thumb: require("../assets/images/presale-detail10.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 4,
              thumb: require("../assets/images/presale-detail11.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
          head: "Legendary Loot Crate",
          headPrice: "Legendary Crate - Total 3000",
          fullCharacters: [
            {
              id: 10,
              thumb: require("../assets/images/crate9.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 5,
              thumb: require("../assets/images/crate10.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 4,
              thumb: require("../assets/images/crate11.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
        },
        "ultra-rare-presale-1": {
          id: "ultra-rare-presale-1",
          title: "Epic",
          desc: "EPIC LOOT CRATE REWARDS",
          quantity: 1,
          stock: 0,
          supply: 13 * 2,
          price: 1.2,
          normalPrice: 1.5,
          discount: "20%",
          thumb: require("../assets/images/epic-box2.png"),
          isInProgress: false,
          thumbNext: null,
          characters: [
            {
              id: 1,
              thumb: require("../assets/images/presale-detail12.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 9,
              thumb: require("../assets/images/presale-detail13.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
          head: "Epic Loot Crate",
          headPrice: "Epic Crate - Total 500",
          fullCharacters: [
            {
              id: 1,
              thumb: require("../assets/images/crate12.png"),
              mintCount: 0,
              mintLimit: 0,
            },
            {
              id: 9,
              thumb: require("../assets/images/crate13.png"),
              mintCount: 0,
              mintLimit: 0,
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState(["chain", "ethFighterPreSaleContract"]),
    tabs() {
      return Object.keys(this.crates).map((crateId) => this.crates[crateId]);
    },
  },
  methods: {
    updateCrateImage(crateId, image) {
      this.crates[crateId].thumb = image;
    },
    async buy(crate) {
      this.currentHash = null;
      const balance = await this.$store.dispatch("getBalance");
      let balanceNum = parseInt(balance["_hex"]);
      if (balanceNum >= crate.price * crate.quantity) {
        crate.isInProgress = true;
        const tx = await this.$store.dispatch("buyMultipleCrates", crate);
        this.currentHash = tx.hash;

        const updateCrateImage = this.updateCrateImage;
        this.ethFighterPreSaleContract.once(
          "CreatePurchased",
          (param1, param2, param3) => {
            console.log(
              "character type ID pulled from this or bonus crate: ",
              param3.toString()
            );
            updateCrateImage(
              crate.id,
              require(`../assets/characterReveals/${param3.toString()}.gif`)
            );
            crate.isInProgress = false;
          }
        );
      } else {
        this.$toastr.Add({
          name: "err1",
          title: "Opps!",
          msg: "Insufficient balance",
          clickClose: false,
          timeout: 5000,
          type: "error",
          style: { backgroundColor: "red" },
        });
        console.log("Insufficient balance");
        // this.$toastr('error', 'Insufficient balance', 'hello')
      }
    },
    setAndScroll(id) {
      this.current = id;
    },
    updateCrateDetails(crateId, details) {
      const { cratePrice, totalCharacterStock } = details;
      this.crates[crateId].price = ethers.utils.formatEther(
        cratePrice.toString()
      );
      this.crates[crateId].stock = parseInt(totalCharacterStock.toString());
    },
    updateCrateMintCountAndLimitInfo(crateId, mintCountAndLimits) {
      const crate = this.crates[crateId];
      const characters = crate.characters;

      let updatedCharacters = [];
      mintCountAndLimits.characterTypeIds.forEach((characterTypeId, idx) => {
        let matchingCharacter = characters.filter(
          (character) => character.id.toString() === characterTypeId.toString()
        )[0];
        updatedCharacters.push({
          ...matchingCharacter,
          mintCount: parseInt(
            mintCountAndLimits.characterTypeMintCounts[idx].toString()
          ),
          mintLimit: parseInt(
            mintCountAndLimits.characterTypeMintLimits[idx].toString()
          ),
        });
      });

      this.crates[crateId].characters = updatedCharacters;
    },
    getCrateDetailsForAllCrates() {
      console.log("Getting current crate prices");
      // FIXME attempt to do reveal animation

      const updateCrateDetails = this.updateCrateDetails;
      const updateCrateMintCountAndLimitInfo = this
        .updateCrateMintCountAndLimitInfo;
      [
        "common-presale-1",
        "rare-presale-1",
        "super-rare-presale-1",
        "ultra-rare-presale-1",
      ].map((crateId) => {
        this.$store.dispatch("getCrateDetails", crateId).then((details) => {
          updateCrateDetails(crateId, details);
        });

        this.$store
          .dispatch("getCharacterMintCountAndLimits", crateId)
          .then((mintCountAndLimits) => {
            updateCrateMintCountAndLimitInfo(crateId, mintCountAndLimits);
          });
      });
    },
  },
  created() {
    if (this.chain) {
      this.getCrateDetailsForAllCrates();
    } else {
      this.$watch("chain", (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.getCrateDetailsForAllCrates();
        }
      });
    }
  },
};
</script>

<style scoped>
</style>
